import { miscFunctions } from 'mnm-webapp';

export const getBodyAsUrlParams = <T>(
    item: T,
    propertyName: string
): string => {
    return miscFunctions.objectToURLParams({
        [propertyName]: JSON.stringify(item),
    });
};
